import { 
    CreateSplashScreenDto, 
    DeleteSplashScreenDto,
    EditSplashScreenDto,
    GetSplashScreenDto, 
    MessageResponseDto, 
    SplashScreenApiFp,
    SplashScreenControllerGet200Response,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseSplashScreenModel = SplashScreenControllerGet200Response;
export type GetSplashScreenModel = GetSplashScreenDto;
export type MutateResponseSplashScreenModel = MessageResponseDto;
export type CreateSplashScreenModel = CreateSplashScreenDto;
export type UpdateSplashScreenModel = EditSplashScreenDto;
export type DeleteSplashScreenModel = DeleteSplashScreenDto;

export interface CreateSplashScreenExtension {
  splashScreen: CreateSplashScreenModel;
  file: File;
}

export interface UpdateSplashScreenExtension {
  splashScreen: UpdateSplashScreenModel;
  file: File;
}

export const apiSplashScreenFp = SplashScreenApiFp(apiConfig);
export const getSplashScreenController = apiSplashScreenFp.splashScreenControllerGet;
export const createSplashScreenController = apiSplashScreenFp.splashScreenControllerCreate;
export const updateSplashScreenController = apiSplashScreenFp.splashScreenControllerEdit;
export const deleteSplashScreenController = apiSplashScreenFp.splashScreenControllerDelete;

export const QueryKeySplashScreen = QueryKey.SplashScreen;
